import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import SelectPadrao from 'react-select';
import ReactExport from 'react-export-excel-fixed-xlsx';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import PedidoItemForm from './pedidoItemForm';
import PedidoHistoricoForm from './pedidoHistoricoForm';
import CotacaoForm from './cotacaoForm';
import consts from '../consts';

import {
	setModoTela, initForm, getListaSolicitacaoAberta, 
	initFormItem, getListaItens, salvarItem, excluirItem, duplicarItem,
	initFormHistorico, getListaHistoricos, salvarHistorico, excluirHistorico,
	initFormCotacao, getListaCotacoes, salvarCotacao, excluirCotacao,
	imprimir, getListaProdutoHistorico
} from './pedidoActions';
import FileUtils from '../common/fileUtils/FileUtils';

class PedidoForm extends Component {

	state = {
		filtro: {
			ids_fornecedores: [],
			ids_transportadoras: [],
			ids_status: []
		}
	}

    componentWillMount() {
		this.props.getListaSolicitacaoAberta();
		this.props.getListaItens(this.props.formularioValues.id || 0);
		this.props.initFormItem(null);
		this.props.getListaHistoricos(this.props.formularioValues.id || 0);
		this.props.initFormHistorico(null);
		this.props.getListaCotacoes(this.props.formularioValues.id || 0);
		this.props.initFormCotacao(null);
    }

	componentWillUnmount() {
		this.props.initFormItem(null);
		this.props.initFormHistorico(null);
		this.props.initFormCotacao(null);
    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		let valorTotalProdutos = 0;
		{(this.props.formularioValues.listaSolicitacoesSelecionadas ? [] : this.props.listaItens).map(item => {
			valorTotalProdutos += parseFloat(item.quantidade || 0) * parseFloat(item.valor || 0);
		})}

		return (
			<>

				{this.modalDuplicacao()}
				{this.modalProdutoHistorico()}
				{this.modalImpressao()}

				<ContentCard>
					{this.props.formularioValues.id > 0 &&
					<div 
						style={{
							paddingLeft: 8,
							paddingRight: 8,
							paddingTop: 8,
							display: 'flex',
							justifyContent: 'space-between',
							backgroundColor: 'rgb(0, 48, 138, 0.85)'
						}}>
						<label style={{ fontSize: 18, color: '#ffffff' }}>Pedido: {this.props.formularioValues.numero}</label>
						<label style={{ fontSize: 18, color: '#ffffff' }}>Total Produtos: R$ {FormatUtils.formatarValorTela(valorTotalProdutos, 2)}</label>
						<label style={{ fontSize: 18, color: '#ffffff' }}>Data: {DateFormat.formatarDataSqlParaTela(this.props.formularioValues.datahora_pedido || DateFormat.getDataAtual())}</label>
					</div>}

					{(this.props.formularioValues.id > 0) &&
					<Row style ={{ padding: 8 }}>
						<Select
							label='Fornecedor'
							placeholder='Informe'
							options={this.props.listaFornecedor}
							cols='12 4 4 4'
							multiple
							value={this.state.filtro.ids_fornecedores}
							onChange={value => {
								this.setState({
									...this.state,
									filtro: {
										...this.state.filtro,
										ids_fornecedores: (value || []).map(item => item.value)
									}
								});
							}} />

						<Select
							label='Transportadora'
							placeholder='Informe'
							options={this.props.listaTransportadora}
							cols='12 4 4 4'
							multiple
							value={this.state.filtro.ids_transportadoras}
							onChange={value => {
								this.setState({
									...this.state,
									filtro: {
										...this.state.filtro,
										ids_transportadoras: (value || []).map(item => item.value)
									}
								});
							}} />

						<Select
							label='Status'
							placeholder='Informe'
							options={this.props.listaStatus}
							cols='12 4 4 4'
							multiple
							value={this.state.filtro.ids_status}
							onChange={value => {
								this.setState({
									...this.state,
									filtro: {
										...this.state.filtro,
										ids_status: (value || []).map(item => item.value)
									}
								});
							}} />
					</Row>}

					<ContentCardBody>

						{(this.props.formularioValues.listaSolicitacoesSelecionadas ? [] : this.props.listaItens).filter(item => {

							if((this.state.filtro.ids_fornecedores || []).length && !(this.state.filtro.ids_fornecedores || []).includes(item.id_fornecedor)) {
								return false;
							}
							if((this.state.filtro.ids_transportadoras || []).length && !(this.state.filtro.ids_transportadoras || []).includes(item.id_transportadora)) {
								return false;
							}
							if((this.state.filtro.ids_status || []).length && !(this.state.filtro.ids_status || []).includes(item.id_status)) {
								return false;
							}

							return true;

						}).map(item => {

							const edicaoAberta = this.props.formularioValuesItem && this.props.formularioValuesItem.id == item.id;

							let statusAtual = this.props.listaStatus.filter(status => status.id == item.id_status)[0];
							const listaStatus = this.props.listaStatus.filter(status => {
								if (statusAtual.id != status.id && (statusAtual.status_possiveis || []).length) {
									return (statusAtual.status_possiveis || []).includes(status.id);
								} 
								return true;
							});

							let prazo = parseInt(item.prazo_solicitacao || 0) - parseInt(item.dias_abertura_solicitacao || 0);

							return (
								<div key={item.id} class='card' style={{ boxShadow: '0 0 1px #00308A, 0 1px 3px rgba(0, 48, 138, 0.8)', marginBottom: 8 }}>
									<div class='card-header border-0' style={{ paddingBottom: 0, paddingTop: 8 }}>
										<h3 class='card-title' style={{ fontWeight: 'bold' }}>{item.nome_produto}</h3>
										{!edicaoAberta &&
										<div class='card-tools'>
											<div style={{ display: 'flex' }}>
												<SelectPadrao
													styles={{
														container: (provided) => ({
															...provided,
															width: 200
														})
													}}
													defaultValue={listaStatus.map(opt => ({ value: String(opt.id), label: opt.valor })).filter(opt => opt.value == item.id_status)[0] || null}
													isClearable={false}
													isSearchable={false}
													isDisabled={readOnly}
													onChange={(data) => {
														if (data.value) {
															this.props.salvarItem({
																...item,
																id_status: data.value,
																quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
																valor: FormatUtils.formatarValorTela(item.valor, 2),
																valor_frete: FormatUtils.formatarValorTela(item.valor_frete, 2),
																data_previsao_entrega: item.data_previsao_entrega,
															});
														}
													}}
													options={listaStatus.map(opt => ({ value: opt.id, label: opt.valor }))} />
													
												<ButtonTable
													type={'primary'}
													icon={'far fa-copy'}
													visible={!readOnly}
													event={() => {
														this.setState({
															...this.state,
															modalDuplicacao: {
																original: {
																	...item
																}
															}
														});
													}} />

												<ButtonTable
													type={'warning'}
													icon={'fas fa-pencil-alt'}
													visible={!readOnly}
													event={() => {
														this.props.initFormItem({
															...item,
															quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
															valor: FormatUtils.formatarValorTela(item.valor, 2),
															valor_frete: FormatUtils.formatarValorTela(item.valor_frete, 2),
															data_previsao_entrega: item.data_previsao_entrega,
															excluir: false
														});
													}} />

												<ButtonTable
													type={'danger'}
													icon={'fas fa-trash-alt'}
													visible={!readOnly}
													event={() => {
														this.props.initFormItem({
															...item,
															quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
															valor: FormatUtils.formatarValorTela(item.valor, 2),
															valor_frete: FormatUtils.formatarValorTela(item.valor_frete, 2),
															data_previsao_entrega: item.data_previsao_entrega,
															excluir: true
														});
													}} />
											</div>
										</div>}
									</div>
									<div class='card-body' style={{ paddingTop: 4, paddingBottom: 8 }}>
										<div class='d-flex justify-content-between align-items-center border-bottom'>
											<div style={{ width:'40%' }}>
												<div>Cliente: <b>{item.nome_cliente || 'Não informado'}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Tipo: <b>{item.nome_tipo}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Categoria: <b>{item.nome_categoria}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Prioridade: <b><span class='badge badge-success' style={{ backgroundColor: item.cor_prioridade, fontSize: 12 }}>{item.nome_prioridade}</span></b></div>
											</div>
											<div style={{ width:'15%' }}>
												{!item.finalizado ? (
													<div>Prazo Atend.: <b style={{ color: prazo <= 0 ? '#b50000' : '#000000' }}>{
														prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
														: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
													}</b></div>
												) : (
													<div>Prazo Atend.: <b>Atendido</b></div>
												)}
											</div>
										</div>
										<div class='d-flex justify-content-between align-items-center border-bottom'>
											<div style={{ width:'40%' }}>
												<div>Fornecedor: <b>{item.nome_fornecedor || 'Não informado'}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Quantidade: <b>{FormatUtils.formatarValorTela(item.quantidade, 2)}</b></div>
											</div>
											<div style={{ width:'30%', display: 'flex' }}>
												<div>Valor: <b>R$ {FormatUtils.formatarValorTela(item.valor, 2)}</b></div>
												<a class='text-muted'
													style={{
														marginLeft: 8,
														cursor: 'pointer'
													}}
													onClick={() => {
														this.props.getListaProdutoHistorico({
															id_produto: item.id_produto,
															id_pedido: item.id_pedido
														});
														this.setState({
															...this.state,
															modalProdutoHistorico: {
																nome_produto: item.nome_produto,
																id_pedido: item.id_pedido
															}
														});
													}}><i class='fas fa-search-dollar fa-primary' style={{ fontSize: 20, color: '#009917' }}></i></a>
											</div>
											<div style={{ width:'15%' }}>
												<div>Forma Pgto: <b>{item.nome_forma_pagamento || 'Não Informada'}</b></div>
											</div>
										</div>
										<div class='d-flex justify-content-between align-items-center'>
											<div style={{ width:'40%' }}>
												<div>Transportadora: <b>{item.nome_transportadora || 'Não informada'}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Frete: <b>{item.nome_frete_tipo || 'Não informado'}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Valor Frete: <b>{FormatUtils.formatarValorTela(item.valor_frete || 0, 2)}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>Prev. Entrega: <b>{item.data_previsao_entrega ? DateFormat.formatarDataSqlParaTela(item.data_previsao_entrega) : 'Não Informada'}</b></div>
											</div>
											<div style={{ width:'15%' }}>
												<div>NF: <b>{item.nota_fiscal || 'Não informada'}</b></div>
											</div>
										</div>
										{edicaoAberta &&
										<div>
											<PedidoItemForm onSubmit={this.props.formularioValuesItem.excluir ? this.props.excluirItem : this.props.salvarItem} />
										</div>}
									</div>
								</div>
							)
						})}
					
						{this.props.formularioValues.listaSolicitacoesSelecionadas &&
						this.solicitacoes()}
					</ContentCardBody>

					{(!this.props.formularioValues.id || !this.props.formularioValues.listaSolicitacoesSelecionadas) ? (
						<Form event={this.props.handleSubmit}>						
							
							<ContentCardFooter>
								<Row alignCenter>
									{this.props.excluir ? (
										<Grid cols='6 6 4 3'>
											<Button
												text='Excluir'
												submit type={'danger'}
												icon={'fa fa-trash'} />
										</Grid>
									) : (!this.props.formularioValues.id ? (
										<Grid cols='6 6 4 3'>
											<Button
												text='Iniciar'
												submit
												disabled={!(this.props.formularioValues.listaSolicitacoesSelecionadas || []).length}
												type={'success'}
												icon={'fa fa-check'} />
										</Grid>
									) : (
										<Grid cols='6 6 4 3'>
											<Button
												text='Adicionar Itens'
												event={() => {
													this.props.initForm({
														...this.props.formularioValues,
														listaSolicitacoesSelecionadas: []
													});
												}}
												type={'success'}
												icon={'fa fa-check'} />
										</Grid>
									))}

									{(!this.props.excluir && this.props.formularioValues.id) &&
									<Grid cols='6 6 4 3'>
										<Button
											text='Imprimir'
											event={() => {
												this.setState({
													...this.state,
													modalImpressao: {
														lista: this.props.listaItens
													}
												});
											}}
											type={'primary'}
											icon={'fa fa-check'} />
									</Grid>}
									
									<Grid cols='6 6 4 3'>
										<Button
											text='Voltar'
											type={'warning'}
											icon={'fa fa-chevron-left'}
											event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
									</Grid>
								</Row>
							</ContentCardFooter>
						</Form>
					) : (
						<ContentCardFooter>
							<Row alignCenter>
								<Grid cols='6 6 4 3'>
									<Button
										text='Salvar Itens'
										disabled={!(this.props.formularioValues.listaSolicitacoesSelecionadas || []).length}
										event={() => {
											this.props.salvarItem({
												...this.props.formularioValues
											});
										}}
										type={'success'}
										icon={'fa fa-check'} />
								</Grid>
								<Grid cols='6 6 4 3'>
									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() => {
											this.props.initForm({
												...this.props.formularioValues,
												listaSolicitacoesSelecionadas: null
											});
										}} />
								</Grid>
							</Row>
						</ContentCardFooter>
					)}
				</ContentCard>

				{(this.props.formularioValues.id && !this.props.excluir) &&
				this.cotacoes()}

				{(this.props.formularioValues.id && !this.props.excluir) &&
				this.historicos()}
			</>
		);
    }

	solicitacoes() {

		let agrupador = null;
		let posicao = 0;

		return (
			<Table responsive>
				<THead>
					<Tr>
						<Th alignCenter>Número</Th>
						<Th alignCenter>
							<div class='icheck-success d-inline'>
								<input type='checkbox' id={`checkboxgeral`} 
									checked={(this.props.formularioValues.listaSolicitacoesSelecionadas || []).length}
									onChange={() => {
										if ((this.props.formularioValues.listaSolicitacoesSelecionadas || []).length) {
											this.props.initForm({
												...this.props.formularioValues,
												listaSolicitacoesSelecionadas: []
											});
										} else {											
											this.props.initForm({
												...this.props.formularioValues,
												listaSolicitacoesSelecionadas: (this.props.listaSolicitacaoAberta || []).map(solicitacao => ({ ...solicitacao }))
											});
										}
									}} />
								<label for={`checkboxgeral`} style={{ marginLeft: 4 }}>
								</label>
							</div>
						</Th>
						<Th alignCenter>Tipo</Th>
						<Th alignCenter>Categoria</Th>
						<Th alignCenter>Prioridade</Th>
						<Th alignCenter>Cliente</Th>
						<Th alignCenter>Produto</Th>
						<Th alignCenter>Quantidade</Th>
						<Th alignCenter>Prazo</Th>
						<Th alignCenter>Usuário</Th>
						<Th alignCenter>Data/Hora</Th>
					</Tr>
				</THead>
				<TBody>
					{this.props.listaSolicitacaoAberta.map(item => {

						let prazo = parseInt(item.prazo || 0) - parseInt(item.dias_abertura || 0);
														
						if (agrupador != item.numero) {
							agrupador = item.numero;
							posicao++;

							let itens = this.props.listaSolicitacaoAberta.filter(itemAux => itemAux.numero == item.numero).length;

							let borderTop= '2px solid rgb(0, 48, 138, 0.8)';

							return (
								<Tr key={item.id} backgroundColor={'#ffffff'} >
									<Td rowspan={itens} alignCenter bold borderTop={borderTop}>{item.numero}</Td>
									<Td alignCenter small title='Selecione' borderTop={borderTop}>
										<div class='icheck-success d-inline'>
											<input type='checkbox' id={`checkbox${item.id}`} 
												checked={this.isSolicitacaoSelecionada(item)}
												onChange={() => {
													this.setSolicitacaoSelecionada(item);
												}} />
											<label for={`checkbox${item.id}`}>
											</label>
										</div>
									</Td>
									<Td alignCenter small borderTop={borderTop}>{item.nome_tipo}</Td>
									<Td alignCenter small borderTop={borderTop}>{item.nome_categoria}</Td>
									<Td alignCenter small borderTop={borderTop}>
										<span class='badge badge-success' style={{ backgroundColor: item.cor_prioridade, fontSize: 12 }}>{item.nome_prioridade}</span>
									</Td>
									<Td alignCenter small borderTop={borderTop}>{item.nome_cliente}</Td>
									<Td alignCenter small borderTop={borderTop}>{item.nome_produto}</Td>
									<Td alignCenter small borderTop={borderTop}>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
									<Td alignCenter small borderTop={borderTop} color={prazo <= 0 ? '#b50000' : '#000000'}>{
										prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
										: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
									}</Td>
									<Td alignCenter small borderTop={borderTop}>{item.nome_usuario}</Td>
									<Td alignCenter small borderTop={borderTop}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}</Td>
								</Tr>
							);
						} else {
							return (
								<Tr key={item.id} backgroundColor={'#ffffff'} >
									<Td alignCenter small title='Selecione'>
										<div class='icheck-success d-inline'>
											<input type='checkbox' id={`checkbox${item.id}`}
												checked={this.isSolicitacaoSelecionada(item)}
												onChange={() => {
													this.setSolicitacaoSelecionada(item);
												}} />
											<label for={`checkbox${item.id}`}>
											</label>
										</div>
									</Td>
									<Td alignCenter small>{item.nome_tipo}</Td>
									<Td alignCenter small>{item.nome_categoria}</Td>
									<Td alignCenter small>
										<span class='badge badge-success' style={{ backgroundColor: item.cor_prioridade, fontSize: 12 }}>{item.nome_prioridade}</span>
									</Td>
									<Td alignCenter small>{item.nome_cliente}</Td>
									<Td alignCenter small>{item.nome_produto}</Td>
									<Td alignCenter small>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
									<Td alignCenter small color={prazo <= 0 ? '#b50000' : '#000000'}>{
										prazo > 0 ? `Falta${prazo == 1 ? '' : 'm'} ${prazo} dia${prazo == 1 ? '' : 's'}`
										: (prazo == 0 ? 'Venceu hoje' : `Vencido há ${prazo * -1} dia${prazo == -1 ? '' : 's'}`)
									}</Td>
									<Td alignCenter small>{item.nome_usuario}</Td>
									<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_solicitacao)}</Td>
								</Tr>
							);
						}
					})}
				</TBody>
			</Table>
		);
	}
	
	setSolicitacaoSelecionada(registro) {
		let listaSelecionadas = (this.props.formularioValues.listaSolicitacoesSelecionadas || []).map(solicitacao => ({ ...solicitacao }));
		if (listaSelecionadas.filter(solicitacao => solicitacao.id == registro.id).length) {
			listaSelecionadas = listaSelecionadas.filter(solicitacao => solicitacao.id != registro.id);
		} else {
			listaSelecionadas.push({
				...registro
			});
		}

		this.props.initForm({
			...this.props.formularioValues,
			listaSolicitacoesSelecionadas: listaSelecionadas
		});
	}

	isSolicitacaoSelecionada(registro) {
		return (this.props.formularioValues.listaSolicitacoesSelecionadas || []).filter(solicitacao => solicitacao.id == registro.id).length > 0;
	}

	historicos() {

		return (
			<div class='card'>
				<div class='card-header p-2'>

					{!this.props.formularioValuesHistorico &&
					<a class='btn btn-app bg-secondary'
						onClick={() => this.props.initFormHistorico({ id_pedido: this.props.formularioValues.id })}>
						<i class='fas fa-comments'></i> Adicionar 
					</a>}

					{(this.props.formularioValuesHistorico && !this.props.formularioValuesHistorico.id) &&
					<PedidoHistoricoForm onSubmit={this.props.formularioValuesHistorico.excluir ? this.props.excluirHistorico : this.props.salvarHistorico} />}
                
				</div>

				<div>
					<div class='tab-content'>
						{this.props.listaHistoricos.map(item => {

							return (
								<div
									style={{
										borderBottom: '1px solid #adb5bd',
										paddingTop: 8,
										paddingLeft: 16,
										paddingBottom: 8,
										paddingRight: 16
									}}>
									<div 
										style={{ 
											display: 'flex',
											justifyContent: 'space-between',
											marginBottom: 8
										}}>
										<strong>{item.nome_usuario}</strong>

										<div	
											style={{ 
												display: 'flex',
												justifyContent: 'flex-end'
											}}>
											{item.id_usuario_inclusao == this.props.sessao.id &&											
											<a class='float-right btn-tool'
												style={{
													paddingTop: 12,
													color: '#6c757d'
												}}
												onClick={() => {
													this.props.initFormHistorico({
														...item,
														id_pedido: this.props.formularioValues.id,
														excluir: false
													});
												}}><i class='fas fa-pencil-alt'></i></a>}
											
											{item.id_usuario_inclusao == this.props.sessao.id &&
											<a class='float-right btn-tool'
												style={{
													paddingTop: 12,
													marginRight: 16,
													color: '#6c757d'
												}}
												onClick={() => {
													this.props.initFormHistorico({
														...item,
														id_pedido: this.props.formularioValues.id,
														excluir: true
													});
												}}><i class='fas fa-trash'></i></a>}
											
											<div
												style={{
													color: '#6c757d'
												}}>
												{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
											</div>
										</div>										
									</div>
									{(this.props.formularioValuesHistorico && this.props.formularioValuesHistorico.id == item.id) ? (
										<PedidoHistoricoForm onSubmit={this.props.formularioValuesHistorico.excluir ? this.props.excluirHistorico : this.props.salvarHistorico} />
									) : (
										<div
											style={{
												backgroundColor: '#f2f0f0',
												padding: 8,
												borderRadius: 10
											}}>
											{(item.descricao || '').split('\n').map(linha => (
												<p key={{linha}} style={{ padding: 0, margin: 0 }}>{linha}</p>
											))}
											{(item.anexos || []).length > 0 &&
											<p style={{ marginTop: 16, marginBottom: 0, paddingBottom: 0 }}>
												{(item.anexos || []).map(anexo => (
													<a key={anexo} class='btn btn-app bg-secondary'
														style={{ height: 30, width: 30, minWidth: 30, paddingTop: 4, marginLeft: 0, marginRight: 4, marginBottom: 0 }}
														onClick={() => window.open(`${consts.URL}/${anexo.arquivo}`, '_blank')}>
														<i class={FileUtils.getFontAwesomeIconePeloNome(anexo.arquivo)}></i>
													</a>
												))}
											</p>}
										</div>
									)}
								</div>
							);
						})}
					</div>
				</div>
				
				{/*
				<div class='card-body'>
					<div class='tab-content'>
						<div class='active tab-pane' id='activity'>
							{this.props.listaHistoricos.map(item => {

								return (
									<div key={item.id} class='post'>
										<div class='user-block'>
											<span class='username' style={{ marginLeft: 0 }}>
												<strong>{item.nome_usuario}</strong>
												{item.id_usuario_inclusao == this.props.sessao.id &&
												<a class='float-right btn-tool'
													onClick={() => {
														this.props.initFormHistorico({
															...item,
															id_pedido: this.props.formularioValues.id,
															excluir: false
														});
													}}><i class='fas fa-pencil-alt'></i></a>}
												{item.id_usuario_inclusao == this.props.sessao.id &&
												<a class='float-right btn-tool'
													onClick={() => {
														this.props.initFormHistorico({
															...item,
															id_pedido: this.props.formularioValues.id,
															excluir: true
														});
													}}><i class='fas fa-trash'></i></a>}
											</span>
											<span class='description' style={{ marginLeft: 0 }}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</span>
										</div>
										{(this.props.formularioValuesHistorico && this.props.formularioValuesHistorico.id == item.id) ? (
											<PedidoHistoricoForm onSubmit={this.props.formularioValuesHistorico.excluir ? this.props.excluirHistorico : this.props.salvarHistorico} />
										) : (
											<>
												{(item.descricao || '').split('\n').map(linha => (
													<p key={{linha}} style={{ padding: 0, margin: 0 }}>{linha}</p>
												))}
												<p style={{ marginTop: 16, marginBottom: 0, paddingBottom: 0 }}>
													{(item.anexos || []).map(anexo => (
														<a key={anexo} class='btn btn-app bg-secondary'
															style={{ height: 30, width: 30, minWidth: 30, paddingTop: 4 }}
															onClick={() => window.open(`${consts.URL}/${anexo.arquivo}`, '_blank')}>
															<i class={FileUtils.getFontAwesomeIconePeloNome(anexo.arquivo)}></i>
														</a>
													))}
												</p>
											</>
										)}
									</div>
								);
							})}
						</div>
					</div>
				</div>*/}
			</div>
		);
	}

	cotacoes() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
	
		let listaCotacoes = this.props.listaCotacoes.map(item => {

			const quantidade = parseFloat(item.quantidade);
			const valorUnitario = parseFloat(item.valor_unitario);
			const percentualIpi = parseFloat(item.percentual_ipi);
			// //Difal
			const percentualIcms = parseFloat(item.aliquota_icms_rs) - parseFloat(item.percentual_icms);
			// const percentualIcms = parseFloat(item.percentual_icms);
			const valorDesconto = parseFloat(item.valor_desconto);
			const valorFrete = parseFloat(item.valor_frete);

			let valorSemImposto = parseFloat((quantidade * valorUnitario).toFixed(2));
			let valorIpi = parseFloat(((percentualIpi * valorSemImposto) / 100).toFixed(2));
			let valorIcms = parseFloat(((percentualIcms * valorSemImposto) / 100).toFixed(2));
			let valorComImposto = parseFloat((valorSemImposto + valorIpi + valorIcms).toFixed(2));
			let valorFinal = parseFloat((valorComImposto - valorDesconto + valorFrete).toFixed(2));
						
			return {
				...item,
				valorSemImposto: valorSemImposto,
				valorIpi: valorIpi,
				valorIcms: valorIcms,
				valorComImposto: valorComImposto,
				valorFinal: valorFinal
			}
		});

		listaCotacoes.sort((a, b) => {
			if (a.nome_produto != b.nome_produto) {
				return a.nome_produto > b.nome_produto ? 1 : -1;
			} else {
				return parseFloat(a.valorFinal || 0) >= parseFloat(b.valorFinal || 0) ? 1 : -1;
			}
		});

		let solicitacoesCotacoes = [];
		let solicitacaoAnterior = null;
		let cor = '#e3e3e3';
		listaCotacoes = listaCotacoes.map(item => {
			solicitacoesCotacoes.push(item.id_solicitacao);
			
			if (item.id_solicitacao != solicitacaoAnterior) {
				cor = cor == '#e3e3e3' ? '#ffffff' : '#e3e3e3';
			}
			solicitacaoAnterior = item.id_solicitacao;

			return {
				...item,
				ordem: solicitacoesCotacoes.filter(sol => sol == item.id_solicitacao).length,
				cor: cor
			};
		});

		return (
			<div class='card'>
				<div class='card-header p-2'>

					{!this.props.formularioValuesCotacao &&
					<a class='btn btn-app bg-secondary'
						onClick={() => this.props.initFormCotacao({ id_pedido: this.props.formularioValues.id, aliquota_icms_rs: '17,00' })}>
						<i class='fas fa-search-dollar'></i> Cotação 
					</a>}

					{!this.props.formularioValuesCotacao &&
					<ExcelFile
						filename={'Cotação'}
						element={
							<a class='btn btn-app bg-secondary' >
								<i class='fas fa-file-excel'></i> Exportar
							</a>
						}>
						<ExcelSheet data={listaCotacoes.map(item => ({
							...item,
							quantidade: parseFloat(item.quantidade),
							valor_unitario: parseFloat(item.valor_unitario),
							valor_desconto: parseFloat(item.valor_desconto),
							valor_frete: parseFloat(item.valor_frete),
							datahora_inclusao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)
						}))} name='Cotação'>
							<ExcelColumn label='Ordem' value='ordem' />
							<ExcelColumn label='Produto' value='nome_produto' />
							<ExcelColumn label='Fornecedor' value='nome_fornecedor' />
							<ExcelColumn label='Quantidade' value='quantidade' type='number' />
							<ExcelColumn label='Vlr Unit.' value='valor_unitario' type='number' />
							<ExcelColumn label='Vlr IPI' value='valorIpi' type='number' />
							<ExcelColumn label='Vlr ICMS' value='valorIcms' type='number' />
							<ExcelColumn label='Vlr Sem Imposto' value='valorSemImposto' type='number' />
							<ExcelColumn label='Vlr Com Imposto' value='valorComImposto' type='number' />
							<ExcelColumn label='Vlr Desconto' value='valor_desconto' type='number' />
							<ExcelColumn label='Vlr Frete' value='valor_frete' type='number' />
							<ExcelColumn label='Vlr Final' value='valorFinal' type='number' />
							<ExcelColumn label='Usuário' value='nome_usuario' />
							<ExcelColumn label='Data/Hora' value='datahora_inclusao' />
						</ExcelSheet>
					</ExcelFile>}

					{(this.props.formularioValuesCotacao && !this.props.formularioValuesCotacao.id) &&
					<CotacaoForm onSubmit={this.props.formularioValuesCotacao.excluir ? this.props.excluirCotacao : this.props.salvarCotacao} />}
                
				</div>
				
				<div class='card-body'>
					<div class='tab-content'>
						<div class='active tab-pane' id='activity'>
							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter></Th>
										<Th alignCenter>Produto</Th>
										<Th alignCenter>Fornecedor</Th>
										<Th alignRight>Qtd.</Th>
										<Th alignRight>Vlr Unit.</Th>
										<Th alignRight>Vlr IPI</Th>
										<Th alignRight>Vlr ICMS</Th>
										<Th alignRight>Vlr Sem Imposto</Th>
										<Th alignRight>Vlr Com Imposto</Th>
										<Th alignRight>Vlr Desconto</Th>
										<Th alignRight>Vlr Frete</Th>
										<Th alignRight>Vlr Final</Th>
										<Th alignCenter>Usuário</Th>
										<Th alignCenter>Data/Hora</Th>
										<Th alignCenter width={100}></Th>
									</Tr>
								</THead>
								<TBody>
									{listaCotacoes.map(item => {

										if (this.props.formularioValuesCotacao && this.props.formularioValuesCotacao.id == item.id) {
											return (
												<Tr key={item.id} backgroundColor={'#ffffff'} >
													<Td colspan={14}>
														<CotacaoForm onSubmit={this.props.formularioValuesCotacao.excluir ? this.props.excluirCotacao : this.props.salvarCotacao} />
													</Td>
												</Tr>
											);
										} else {									

											return (
												<Tr key={item.id} backgroundColor={item.cor} >
													<Td alignCenter small>
														<div
															style={{
																width: 24,
																height: 24,
																color: '#ffffff',
																backgroundColor: item.ordem == 1 ? '#00872b' : '#8a2700',
																borderRadius: '50%',
																fontSize: 16,
																fontWeight: 'bold',
																verticalAlign: 'center'
															}}>
															{item.ordem}
														</div>
													</Td>
													<Td alignCenter small>{item.nome_produto}</Td>
													<Td alignCenter small>{item.nome_fornecedor}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valor_unitario, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valorIpi, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valorIcms, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valorSemImposto, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valorComImposto, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valor_desconto, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valor_frete, 2)}</Td>
													<Td alignRight small>R$ {FormatUtils.formatarValorTela(item.valorFinal, 2)}</Td>
													<Td alignCenter small>{item.nome_usuario}</Td>
													<Td alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
													<Td alignCenter small>
														<ButtonTable
															type={'warning'}
															icon={'fas fa-pencil-alt'}
															visible={true}
															small
															event={() => {
																this.props.initFormCotacao({
																	...item,
																	quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
																	valor_unitario: FormatUtils.formatarValorTela(item.valor_unitario, 2),
																	percentual_ipi: FormatUtils.formatarValorTela(item.percentual_ipi, 2),
																	percentual_icms: FormatUtils.formatarValorTela(item.percentual_icms, 2),
																	valor_desconto: FormatUtils.formatarValorTela(item.valor_desconto, 2),
																	aliquota_icms_rs: FormatUtils.formatarValorTela(item.aliquota_icms_rs, 2),
																	valor_frete: FormatUtils.formatarValorTela(item.valor_frete, 2),
																	excluir: false
																});
															}} />

														<ButtonTable
															type={'danger'}
															icon={'fas fa-trash-alt'}
															visible={true}
															small
															event={() => {
																this.props.initFormCotacao({
																	...item,
																	quantidade: FormatUtils.formatarValorTela(item.quantidade, 2),
																	valor_unitario: FormatUtils.formatarValorTela(item.valor_unitario, 2),
																	percentual_ipi: FormatUtils.formatarValorTela(item.percentual_ipi, 2),
																	percentual_icms: FormatUtils.formatarValorTela(item.percentual_icms, 2),
																	valor_desconto: FormatUtils.formatarValorTela(item.valor_desconto, 2),
																	aliquota_icms_rs: FormatUtils.formatarValorTela(item.aliquota_icms_rs, 2),
																	valor_frete: FormatUtils.formatarValorTela(item.valor_frete, 2),
																	excluir: true
																});
															}} />
													</Td>
												</Tr>
											);
										}
									})}
								</TBody>
							</Table>
						</div>
					</div>
				</div>
			</div>
		);
	}

	modalDuplicacao() {

		if (!this.state.modalDuplicacao) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-md' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Duplicar Solicitação</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalDuplicacao: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Row alignCenter>
								<LabelAndInputNumber
									label='Quantidade de origem' placeholder='Informe'
									cols='12 12 12 12'
									readOnly={'readOnly'}
									mask={2}
									value={FormatUtils.formatarValorTela(this.state.modalDuplicacao.original.quantidade, 2)}
									onChange={(data) => {

									}} />
							</Row>
							<Row alignCenter>
								<LabelAndInputNumber
									label='Quantidade da nova solicitação' placeholder='Informe'
									cols='12 12 12 12'
									mask={2}
									value={this.state.modalDuplicacao.nova_quantidade}
									onChange={(data) => {
										this.setState({
											...this.state,
											modalDuplicacao: {
												...this.state.modalDuplicacao,
												nova_quantidade: data.target.value
											}
										});
									}} />
							</Row>
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<Row alignCenter
								style={{
									paddingRight: 10,
									paddingBottom: 4 
								}}>
								<Grid cols='12 12 12 12'>
									<Button
										text='Confirmar'
										type={'primary'}
										icon={'fa fa-chevron-left'}
										event={() => {
											this.props.duplicarItem({
												...this.state.modalDuplicacao.original,
												nova_quantidade: this.state.modalDuplicacao.nova_quantidade
											}, () => {
												this.setState({ ...this.state, modalDuplicacao: null });
											});
										}} />
								</Grid>
							</Row>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalProdutoHistorico() {

		if (!this.state.modalProdutoHistorico) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>{this.state.modalProdutoHistorico.nome_produto}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalProdutoHistorico: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>Pedido</Th>
										<Th alignCenter>Solicitação</Th>
										<Th alignCenter>Fornecedor</Th>
										<Th alignCenter>Forma Pagamento</Th>
										<Th alignCenter>Status</Th>
										<Th alignRight>Quantidade</Th>
										<Th alignRight>Valor</Th>
										<Th></Th>
									</Tr>
								</THead>
								<TBody>
									{this.props.listaProdutoHistorico.map((item, i) => {

										let proximo = this.props.listaProdutoHistorico[i + 1];
										let diferenca = 0;
										if (proximo) {
											diferenca = 100 - parseFloat(((parseFloat(item.valor) * 100) / parseFloat(proximo.valor)).toFixed(2));
										}

										
										return (
											<Tr key={item.id} backgroundColor={'#ffffff'} >
												{item.id_pedido != this.state.modalProdutoHistorico.id_pedido ? (
													<Td alignCenter small>{item.numero_pedido}</Td>
												) : (
													<Td  alignCenter small>Atual</Td>
												)}
												<Td alignCenter small>{item.numero_solicitacao}</Td>
												<Td alignCenter small>{item.nome_fornecedor || 'Não informado'}</Td>
												<Td alignCenter small>{item.nome_forma_pagamento || 'Não informada'}</Td>
												<Td alignCenter small>{item.nome_status || 'Não informado'}</Td>
												<Td alignRight>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
												<Td alignRight>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
												<Td>
													{diferenca < 0 ? (
														<small class='text-danger'>
															<i class='fas fa-arrow-up' style={{ marginRight: 4 }}></i>
															{FormatUtils.formatarValorTela(diferenca * -1, 2)}%
														</small>
													) : (diferenca > 0 ? (
														<small class='text-success'>
															<i class='fas fa-arrow-down' style={{ marginRight: 4 }}></i>
															{FormatUtils.formatarValorTela(diferenca, 2)}%
														</small>
													) : (
														<small class='text-primary'>
															<i class='fas fa-equals' style={{ marginRight: 4 }}></i>
															{FormatUtils.formatarValorTela(diferenca, 2)}%
														</small>
													))}
												</Td>
											</Tr>
										);
									})}
								</TBody>
							</Table>
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
						</div>
					</div>
				</div>
			</div>
        );
    }

	modalImpressao() {

		if (!this.state.modalImpressao) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header'>
							<h4 class='modal-title'>Impressão</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, modalImpressao: null })}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ maxHeight: window.innerHeight - 200, overflowY: 'scroll' }}>
							<Table responsive>
								<THead>
									<Tr>
										<Th alignCenter>
											<div class='icheck-success d-inline'>
												<input type='checkbox' id={`checkbox-impressao-geral`} 
													checked={this.state.modalImpressao.lista.filter(itemAux => itemAux.imprimir).length}
													onChange={() => {
														if (this.state.modalImpressao.lista.filter(itemAux => itemAux.imprimir).length) {
															this.setState({
																...this.state,
																modalImpressao: {
																	...this.state.modalImpressao,
																	lista: this.state.modalImpressao.lista.map(itemAux => ({
																		...itemAux,
																		imprimir: false
																	}))
																}
															});
														} else {											
															this.setState({
																...this.state,
																modalImpressao: {
																	...this.state.modalImpressao,
																	lista: this.state.modalImpressao.lista.map(itemAux => ({
																		...itemAux,
																		imprimir: true
																	}))
																}
															});
														}
													}} />
												<label for={`checkbox-impressao-geral`} style={{ marginLeft: 4 }}>
												</label>
											</div>
										</Th>
										<Th alignCenter>Produto</Th>
										<Th alignCenter>Cliente</Th>
										<Th alignCenter>Fornecedor</Th>
										<Th alignCenter>Quantidade</Th>
										<Th alignCenter>Valor</Th>
										<Th alignCenter>Transportadora</Th>
										<Th alignCenter>Status</Th>
									</Tr>
								</THead>
								<TBody>
									{this.state.modalImpressao.lista.map(item => {
										
										return (
											<Tr key={item.id} backgroundColor={'#ffffff'} >
												<Td alignCenter small title='Selecione'>
													<div class='icheck-success d-inline'>
														<input type='checkbox' id={`checkbox-impressao-${item.id}`} 
															checked={item.imprimir}
															onChange={() => {
																this.setState({
																	...this.state,
																	modalImpressao: {
																		...this.state.modalImpressao,
																		lista: this.state.modalImpressao.lista.map(itemAux => ({
																			...itemAux,
																			imprimir: itemAux.id == item.id ? !itemAux.imprimir : itemAux.imprimir
																		}))
																	}
																});
															}} />
														<label for={`checkbox-impressao-${item.id}`}>
														</label>
													</div>
												</Td>
												<Td alignCenter small>{item.nome_produto || 'Não informado'}</Td>
												<Td alignCenter small>{item.nome_cliente || 'Não informado'}</Td>
												<Td alignCenter small>{item.nome_fornecedor || 'Não informado'}</Td>
												<Td alignCenter small>{FormatUtils.formatarValorTela(item.quantidade, 2)}</Td>
												<Td alignCenter small>{FormatUtils.formatarValorTela(item.valor, 2)}</Td>
												<Td alignCenter small>{item.nome_transportadora || 'Não informada'}</Td>
												<Td alignCenter small>{item.nome_status || 'Não informado'}</Td>
											</Tr>
										);
									})}
								</TBody>
							</Table>
						</div>
						<div class=''>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<Row alignCenter
								style={{
									paddingRight: 10,
									paddingBottom: 4 
								}}>
								<Grid cols='12 6 4 4'>
									<Button
										text='Imprimir'
										type={'primary'}
										icon={'fa fa-chevron-left'}
										event={() => {
											this.props.imprimir({
												...this.props.formularioValues,
												lista: this.state.modalImpressao.lista.filter(itemAux => itemAux.imprimir)
											});
										}} />
								</Grid>
							</Row>
						</div>
					</div>
				</div>
			</div>
        );
    }
}

PedidoForm = reduxForm({form: 'pedidoForm', destroyOnUnmount: false})(PedidoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('pedidoForm')(state),
	formularioValuesItem: getFormValues('pedidoItemForm')(state),
	formularioValuesHistorico: getFormValues('pedidoHistoricoForm')(state),
	formularioValuesCotacao: getFormValues('pedidoCotacaoForm')(state),
	registro: state.pedido.registro,
	listaSolicitacaoAberta: state.pedido.listaSolicitacaoAberta,
	listaItens: state.pedido.listaItens,
	listaStatus: state.compraStatus.listaSelect,
	listaFornecedor: state.fornecedor.listaSelect,
	listaTransportadora: state.transportadora.listaSelect,
	listaHistoricos: state.pedido.listaHistoricos,
	listaCotacoes: state.pedido.listaCotacoes,
	listaProdutoHistorico: state.pedido.listaProdutoHistorico
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, getListaSolicitacaoAberta, 
	initFormItem, getListaItens, salvarItem, excluirItem, duplicarItem,
	initFormHistorico, getListaHistoricos, salvarHistorico, excluirHistorico,
	initFormCotacao, getListaCotacoes, salvarCotacao, excluirCotacao,
	imprimir, getListaProdutoHistorico
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PedidoForm);
